import React from "react";
import { PageHeader } from "@/components/common";
import { ArrowSquareOut } from "@phosphor-icons/react";

const GROUPS = [
  {
    title: "Official IRS sources",
    links: [
      { label: "About Form 1098-T", desc: "Tuition statement from your school — used to match expenses to withdrawals.", url: "https://www.irs.gov/forms-pubs/about-form-1098-t" },
      { label: "About Form 1099-Q", desc: "Distributions from 529 plans — what your plan sends you and the IRS each year.", url: "https://www.irs.gov/forms-pubs/about-form-1099-q" },
      { label: "About Form 5329", desc: "Additional taxes on QTPs and other accounts — reports the 10% additional tax on a non-qualified distribution.", url: "https://www.irs.gov/forms-pubs/about-form-5329" },
      { label: "Eligible educational institution (IRS)", desc: "How the IRS defines a qualifying school.", url: "https://www.irs.gov/credits-deductions/individuals/eligible-educational-institution" },
      { label: "IRC §529 (full statute)", desc: "The tax-code section that governs 529 plans — the primary source Pub 970 interprets.", url: "https://www.law.cornell.edu/uscode/text/26/529" },
      { label: "IRS Publication 970", desc: "Tax benefits for education — the definitive 529 reference.", url: "https://www.irs.gov/publications/p970" },
    ],
  },
  {
    title: "School & program eligibility",
    links: [
      { label: "Apprenticeship Finder (DOL)", desc: "Search and verify DOL-registered apprenticeship programs — the eligibility check for apprenticeship 529 use.", url: "https://www.apprenticeship.gov/apprenticeship-finder" },
      { label: "DAPIP — Dept. of Education school database", desc: "Look up whether a school is eligible for federal student aid (and therefore 529-eligible).", url: "https://ope.ed.gov/dapip/" },
      { label: "FAFSA", desc: "Free Application for Federal Student Aid — the starting point for financial aid.", url: "https://studentaid.gov/h/apply-for-aid/fafsa" },
      { label: "Federal School Code List (FSA Partners)", desc: "Search by school name to find the federal code used on FAFSA and 529 forms.", url: "https://fsapartners.ed.gov/knowledge-center/library/resource-type/Federal%20School%20Code%20Lists" },
    ],
  },
  {
    title: "Good explainers",
    links: [
      { label: "529-to-Roth IRA rollover", desc: "Rules for rolling unused 529 funds to a Roth IRA — the $35,000 lifetime limit and 15-year account requirement.", url: "https://www.savingforcollege.com/article/roll-over-529-plan-funds-to-a-roth-ira" },
      { label: "Savingforcollege — 529 distribution timing", desc: "Practical guide to when to take 529 withdrawals to avoid tax issues.", url: "https://www.savingforcollege.com/article/timing-of-529-plan-distributions-must-match-qualified-expenses" },
      { label: "What's new for 529s in 2026 (OBBBA)", desc: "Plain-language guide to the 2025–26 changes: the higher K-12 limit, expanded K-12 expenses, and credentialing.", url: "https://www.savingforcollege.com/article/529-plan-new-rules-changes" },
    ],
  },
];

export default function Resources() {
  return (
    <div>
      <PageHeader title="Resource Library" subtitle="Curated links to IRS publications, school lookup tools, and trusted 529 guides." />
      <div className="mx-auto max-w-2xl space-y-6">
        {GROUPS.map((g) => (
          <div key={g.title}>
            <h2 className="mb-2 text-xs font-bold uppercase tracking-wide text-[#6b7280]">{g.title}</h2>
            <div className="space-y-1.5">
              {g.links.map((l) => (
                <a key={l.url} href={l.url} target="_blank" rel="noreferrer"
                  className="flex items-start gap-3 rounded-lg border border-[#C2C9D1] bg-white px-4 py-2.5 text-left transition-colors hover:border-[#034AA2] hover:bg-[#F4F7FB]"
                  data-testid={`resource-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  <ArrowSquareOut size={16} weight="bold" className="mt-0.5 shrink-0 text-[#034AA2]" />
                  <div>
                    <div className="text-sm font-bold text-[#034AA2]">{l.label}</div>
                    <div className="text-xs text-[#6b7280]">{l.desc}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
        <div className="rounded-lg border border-[#C2C9D1] bg-[#F7F8FA] px-4 py-3 text-xs text-[#6b7280]">
          This app is a record-keeping tool, not tax or legal advice. For tax questions specific to your situation, consult a qualified tax professional.
        </div>
      </div>
    </div>
  );
}
